// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headline .standard {
  margin: 0px;
  padding: 0 8px 0 0;
  border-radius: 5px;
  margin-bottom: 1em;
}
.headline .standard.active {
  color: var(--link);
}
.headline .meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 14px;
  color: var(--text-de);
  margin-bottom: 2px;
}
.headline .meta > * {
  margin-right: 8px;
  position: relative;
}
.headline .age {
  text-transform: uppercase;
  font-size: 14px;
}
.headline .themeDot {
  width: 8px;
  height: 8px;
  border-radius: 10px;
  border: solid 2px;
  position: relative;
  top: -1px;
}
`, "",{"version":3,"sources":["webpack://./src/events/headline.less"],"names":[],"mappings":"AAAA;EAEE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAAF;AACE;EACC,kBAAA;AACH;AARA;EAYE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;AADF;AAhBA;EAoBE,iBAAA;EACA,kBAAA;AADF;AApBA;EAyBE,yBAAA;EACA,eAAA;AAFF;AAxBA;EA8BE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AAHF","sourcesContent":[".headline {\n\t.standard {\n\t\tmargin: 0px;\n\t\tpadding: 0 8px 0 0;\n\t\tborder-radius: 5px;\n\t\tmargin-bottom: 1em;\n\t\t&.active{\n\t\t\tcolor: var(--link);\n\t\t}\n\t}\n\n\t.meta {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\t\tfont-size: 14px;\n\t\tcolor: var(--text-de);\n\t\tmargin-bottom: 2px;\n\t}\n\t.meta > * {\n\t\tmargin-right: 8px;\n\t\tposition: relative;\n\t}\n\n\t.age {\n\t\ttext-transform: uppercase;\n\t\tfont-size: 14px;\n\t}\n\n\t.themeDot {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder-radius: 10px;\n\t\tborder: solid 2px;\n\t\tposition: relative;\n\t\ttop: -1px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
